import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createReducer } from '@reduxjs/toolkit';
import { resetTariffData, setSelectedServices, setSelectedTimeSlot, setTariffServicesData } from "../actions/legacy/common";
export var tariffServices = createReducer({
  tariffServices: null,
  selectedTimeSlot: null
}, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, setTariffServicesData.type, function (state, _ref) {
  var payload = _ref.payload;
  state.tariffServices = payload;
}), setSelectedServices.type, function (state, _ref2) {
  var payload = _ref2.payload;
  state.tariffServices = payload;
}), setSelectedTimeSlot.type, function (state, _ref3) {
  var payload = _ref3.payload;
  state.selectedTimeSlot = payload;
}), resetTariffData.type, function (state) {
  state.tariffServices = null;
  state.selectedTimeSlot = null;
}));